import CMSModal from './CMSModal';

export type LimitationsModalInfo = {
	main_title: string;
	triggerText: string;
	premiumService: {
		title: string;
		description: string;
	};
	regularService: {
		title: string;
		description: string;
	};
};

type Props = {
	limitationsInfo: LimitationsModalInfo;
	onOpen?: () => void;
};

const LimitationsModalTrigger: React.FC<Props> = ({ limitationsInfo, onOpen }) => {
	let content = (
		<>
			<div className="popup-info mb-4">
				<strong className="title text-[#0d2c54] text-[16px] font-bold block mb-2">{limitationsInfo?.premiumService?.title}</strong>
				<p className="text-[#656d79] text-[14px] leading-relaxed" dangerouslySetInnerHTML={{ __html: limitationsInfo?.premiumService?.description }} />
			</div>
			<div className="popup-info">
				<strong className="title text-[#0d2c54] text-[16px] font-bold block mb-2">{limitationsInfo?.regularService?.title}</strong>
				<p className="text-[#656d79] text-[14px] leading-relaxed" dangerouslySetInnerHTML={{ __html: limitationsInfo?.regularService?.description }} />
			</div>
		</>
	);
	return (
		<CMSModal
			className="max-w-[700px] max-h-[500px]"
			trigger={
				<a id="open-modal-limitations" href="#" className="relative text-[#656d79] no-underline">
					{limitationsInfo?.triggerText}
				</a>
			}
			title={limitationsInfo?.main_title}
			content={content}
			onOpen={onOpen}
		/>
	);
};

export default LimitationsModalTrigger;
